module.exports = __webpack_public_path__ + "media/images/top-design-02-85fa61bc4f99aed12a465d8772be3363.jpg";